import React, { type ReactNode, useEffect, useRef, useState } from 'react'

import * as S from './styled'

type ScrollContentProps = {
  className?: string
  maxHeight?: number
  children: ReactNode
  maskPercentage?: number
  hideScrollbar?: boolean
}

export const ScrollContent = ({
  className,
  maxHeight,
  maskPercentage = 20,
  children,
  hideScrollbar,
}: ScrollContentProps) => {
  const containerRef = useRef<HTMLDivElement>(null)
  const topRef = useRef<HTMLDivElement>(null)
  const bottomRef = useRef<HTMLDivElement>(null)
  const [isScrolledTop, setIsScrolledTop] = useState(true)
  const [isScrolledBottom, setIsScrolledBottom] = useState(true)
  const [contentOverflow, setContentOverflow] = useState(false)

  useEffect(() => {
    if (topRef.current && bottomRef.current && maxHeight) {
      const topObserver = new IntersectionObserver((payload) =>
        setIsScrolledTop(payload[0].isIntersecting),
      )
      const bottomObserver = new IntersectionObserver((payload) =>
        setIsScrolledBottom(payload[0].isIntersecting),
      )

      topObserver.observe(topRef.current)
      bottomObserver.observe(bottomRef.current)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (containerRef.current) {
      setContentOverflow(containerRef.current.scrollHeight > containerRef.current.clientHeight)
    }
  }, [children])

  if (!maxHeight) {
    return children
  }

  return (
    <S.Container
      ref={containerRef}
      className={className}
      maxHeight={maxHeight}
      isScrolledTop={isScrolledTop}
      isScrolledBottom={isScrolledBottom}
      maskPercentage={maskPercentage}
      hideScrollbar={hideScrollbar || !contentOverflow}
    >
      <S.ScrollChecker ref={topRef} />
      {children}
      <S.ScrollChecker ref={bottomRef} />
    </S.Container>
  )
}
